module.exports = __webpack_public_path__ + "img/progress-scribble-bar-color7.f9cd381f.gif";